module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesCool@2x.0de6b4e.webp";